<script setup lang="ts">
import type { SlugBodyItem } from '~/components/slug/body';

useSeoMeta({
  title: 'Masáže | Okgym - Fitcentrum | Pardubický Kraj',
  description:
    'Fitness, Gym, Solarium, Box - Lepší nabídku nenajdeš! Pro studenty zvýhodněná nabídka jen v Okgym',
});

const services: SlugBodyItem[] = [
  {
    title: 'Relaxační masáž',
    description: `<p><b>O co jde:</b> Jemná terapeutická masáž s využitím prémiových olejů.</p><br><p><b>Pro koho:</b> Ideální pro každého (sportovce i nesportovce) bez jakýchkoliv zdravotních omezení.</p><br><p><b>Účinek:</b> Dokonale uvolňuje napětí ve svalech i na duši, vyplavuje toxiny a posiluje imunitu.</p>`,
    image: {
      url: '/images/masaze/1.webp',
      alt: 'Žena při relaxační masáži',
    },
  },
  {
    title: 'Sportovní masáž',
    description: `<p><b>O co jde:</b> Dynamická masáž s důraznějšími a rychlejšími hmaty.</p><br><p><b>Pro koho:</b> Pro aktivní lidi před výkonem nebo po něm.</p><br><p><b>Účinek:</b> Rychle prokrví svaly, připraví je na zátěž a výrazně urychlí následnou regeneraci.</p>`,
    image: {
      url: '/images/masaze/2.webp',
      alt: 'Sportovní masáž zad',
    },
  },
  {
    title: 'Havajská masáž',
    description: `<p><b>O co jde:</b> Rytmická masáž prováděná táhlými hmaty dlaní a předloktí za doprovodu exotické hudby.</p><br><p><b>Pro koho:</b> Pro ty, kteří potřebují hluboké fyzické i psychické uvolnění.</p><br><p><b>Účinek:</b> Stimuluje krevní a lymfatický systém, detoxikuje tělo a odstraňuje svalovou ztuhlost.</p>`,
    image: {
      url: '/images/masaze/3.webp',
      alt: 'Tradiční havajská masáž předloktím',
    },
  },
  {
    title: 'Harmonizace těla',
    description: `<p><b>O co jde:</b> Speciální kombinace relaxační a thajské masáže s prvky ájurvédy a aromaterapie.</p><br><p><b>Pro koho:</b> Pro lidi pod velkým tlakem a stresem.</p><br><p><b>Účinek:</b> Obnovuje tok energie, odbourává stres a startuje přirozené samoléčebné procesy v těle.</p>`,
    image: {
      url: '/images/masaze/1.webp',
      alt: 'Harmonizační masáž a aromaterapie',
    },
  },
  {
    title: 'Masáž lávovými kameny',
    description: `<p><b>O co jde:</b> Luxusní rituál s využitím tisíce let starých čedičových kamenů z Havaje, nahřátých na 50 °C.</p><br><p><b>Pro koho:</b> Pro nejnáročnější klienty, kteří milují hluboké teplo.</p><br><p><b>Účinek:</b> Teplo z kamenů uvolňuje měkké tkáně, odbourává svalové bloky a přivede vás až ke stavu hlubokého spánku.</p>`,
    image: {
      url: '/images/masaze/2.webp',
      alt: 'Masáž nahřátými lávovými kameny',
    },
  },
];

const text = {
  title: 'Uvolněte ztuhlé svaly a nechte své tělo hluboce vydechnout.',
  subtitle: 'Masáže',
  description:
    'Naše zkušená a empatická masérka přistupuje ke každému individuálně. Dokáže se nacítit na správnou intenzitu podle vaší ztuhlosti a potřeb. Užijte si masáž v naprostém tichu, nebo s psychickou podporou – s vůněmi a hudbou na míru.',
} as const;
</script>

<template>
  <PageContainer no-alignment no-padding>
    <SlugHeader
      :title="text.title"
      :subtitle="text.subtitle"
      :description="text.description"
      icon="icon:massage"
      :image-header="{
        url: '/images/masaze/header.webp',
        alt: 'Lezecká stěna',
      }"
      :links="[
        {
          to: '/cenik-masaze.pdf',
          label: 'Ceník',
          icon: 'icon:document',
        },
      ]"
    />
    <SlugBody :items="services" />
    <Feed />
    <IndexGallery />
  </PageContainer>
</template>
